<template>
  <div
    class="duoke-mobile-download"
    @click="(adminShow = false), (saleShow = false)"
  >
    <div
      :class="{point: true, 'download-error': !android.admin || !android.sale}"
      v-if="downloadClient !== 'IOS'"
    ></div>
    <div class="logo-app"></div>
    <div class="download-area">
      <div class="download-air">
        <mc-download-button
          @click.native.stop="downloadApp('admin')"
          @googlePlay="handleGooglePlay('admin')"
          @download="handleDownload('admin')"
          icon="mc_g"
          text="MC Gérant"
          :version="adminV"
          :showDownload="adminShow"
        />
        <mc-download-button
          @click.native.stop="downloadApp('sale')"
          @googlePlay="handleGooglePlay('sale')"
          @download="handleDownload('sale')"
          icon="mc_c"
          text="MC Seller"
          :version="saleV"
          :showDownload="saleShow"
        />
        <mc-download-button
          @click.native.stop="downloadZ()"
          icon="mc_z"
          text="MicroStore Manager"
        />
        <mc-download-button
          @click.native.stop="downloadL()"
          icon="mc_l"
          text="MicroStore"
        />
        <mc-download-button
          v-if="showPrinter"
          @click.native.stop="downloadP()"
          icon="mc_p"
          text="MC Printer"
        />
        <mc-download-button
          @click.native.stop="downloadApp(warehouseKey)"
          @download="handleDownload(warehouseKey)"
          :version="warehouseV"
          :showDownload="false"
          icon="mc_w"
          text="MC Warehouse"
        />
      </div>
    </div>
    <div
      class="tip_img"
      v-show="showTips"
      @click.self="showTips = !showTips"
    >
      <div class="select-block">
        <img
          class="language-icon"
          src="./assets/language.png"
        />
        <select
          name="language"
          id="language"
          class="language-selector"
          v-model="selectLang"
          @change="handleChange"
        >
          <option
            v-for="i in languageList"
            :key="i.key"
            :value="i.key"
          >
            {{i.title}}
          </option>
        </select>
      </div>
      <div class="tip-img-block">
        <div>1:{{firstTip}}</div>
        <div>2:{{secondTip}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { isWeiXin } from "../../utils/utils"
import McDownloadButton from "./components/McButton"
import mixin from '../mc/mixin'

export default {
  name: "",

  mixins:[mixin],

  components: {
    McDownloadButton
  },

  data(){
    return {
      warehouseKey:"warehouse", // 仓管端的使用key
      warehouseAndroidAppPid:"MC-WAREHOUSE-002" // 仓管端的app_pid
    }
  },

  props: {},

  watch: {},
  async created() {
    this.selectLang = this.lang
    this.getUrlParams()
    // document.querySelector('link[rel="icon"]').href = mcIcon
    if (this.downloadClient !== "IOS") {
      window.showLoading()
      const adminRes = this.adminV
        ? await this.getMCUrl(91, this.adminV)
        : await this.getMCUrl(91)
      const saleRes = this.saleV
        ? await this.getMCUrl(92, this.saleV)
        : await this.getMCUrl(92)
      const warehouseRes = await this.getMCUrl(this.warehouseAndroidAppPid)
      if (adminRes && adminRes.data) {
        const androidAdminUrl = adminRes.data.data.version_info.url
        const androidSaleUrl = saleRes.data.data.version_info.url
        const androidWarehouseResUrl = warehouseRes.data.data.version_info.url
        this.android = {
          admin: androidAdminUrl,
          sale: androidSaleUrl,
          warehouse: androidWarehouseResUrl
        }
      }
      window.hideLoading()
    }
  },

  methods: {
    async downloadApp(app) {
      if (this.downloadClient === "IOS") {
        // const version = app === 'admin' ? this.adminV : this.saleV
        let downloadObj = {}
        switch(app){
          case 'admin':
            downloadObj = {
              url:'https://api2.dokkr.net/index.php/download/plist/51/',
              version: this.adminV
            }
            break
          case 'sale':
            downloadObj = {
              url: 'https://api2.dokkr.net/index.php/download/plist/52/',
              version: this.saleV
            }
            break
          case this.warehouseKey:
            downloadObj = {
              url: "https://apps.apple.com/us/app/mc-warehouse/id6736793448",
              version:""
            }
        }
        const version = downloadObj.version || ""
        const urlValue = downloadObj.url || ""
        if((version || '') !== ''){
          const obj = {
            admin:'https://api2.dokkr.net/index.php/download/plist/51/',
            sale:'https://api2.dokkr.net/index.php/download/plist/52/'
          }
          const url = `itms-services:///?action=download-manifest&url=${urlValue}${version}`
          window.location.href = url
          window.parent.postMessage({ url: url }, "*")
        }else{
          window.location.href = this.ios[app]
          window.parent.postMessage({ url: this.ios[app] }, "*")
        }
      } else {
        if (isWeiXin()) {
          await this.getLanguageList(this.lang)
          this.showTips = true
          return
        }
        if (this.adminV || this.saleV) {
          this.handleDownload(app)
        } else {
          switch(app){
            case "admin":
              this.adminShow = true
              this.saleShow = false
              this.warehouseShow = false
              break
            case "sale":
              this.saleShow = true
              this.adminShow = false
              this.warehouseShow = false
              break
            case this.warehouseKey:
              this.handleDownload(this.warehouseKey)
              this.adminShow = false
              this.saleShow = false
              this.warehouseShow = false
              break
            default:
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.duoke-mobile-download {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  position: relative;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  background: #f4f5f6;
  > .point {
    width: 1px;
    height: 1px;
    position: absolute;
    right: 50px;
    top: 50px;
    background: #999999;
  }
  > .download-error {
    background: red;
  }
}
.logo-app {
  margin-top: 54px;
  margin-left: auto;
  margin-right: auto;
  width: 170px;
  height: 130px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url('./assets/mc_logo.png');
}
.download-area {
  margin-top: 63px;
}
.footer {
  margin-top: 200px;
  text-align: center;
  font-size: 9px;
}
.tip_img {
  z-index: 99999;
  position: absolute;
  height: 100vh;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-image: url(./assets/mcapp.png);
  background-color: #fff;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  > .select-block {
    display: flex;
    align-items: center;
    margin: 10px 0 0 10px;
    > .language-icon {
      width: 16px;
    }
    > .language-selector {
      color: #999;
      width: auto;
      background-color: transparent;
      border: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      margin-left: 5px;

      &:focus {
        outline: 0;
      }
      &::-ms-expand {
        display: none;
      }
    }
  }
  > .tip-img-block {
    margin-top: 50vh;
    padding-left: 20px;
    line-height: 25px;
    background-color: #ffffff;
    font-size: 16px;
  }
}
</style>
